import {ReactNode, useContext, useEffect, useState} from "react";
import QRCodeStyle from "../../../api/qr-code/style/QRCodeStyle";
import Page from "../../../api/Page";
import GetListQuery from "../../../api/qr-code/style/GetListQuery";
import QRCodeStyleContext from "./QRCodeStyleContext";
import QRCodeStyleApi from "../../../api/qr-code/style/QRCodeStyleApi";
import AuthContext from "../../auth/AuthContext";
import CreateAndPutPayload from "../../../api/qr-code/style/CreateAndPutPayload";

type Props = { children: ReactNode };

/**
 * Default query.
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaultQuery: GetListQuery = {};

function WrapQRCodeStyleContext(props: Props) {
    /**
     * Data from API.
     * Will be reloaded when query is changed.
     * @since 0.1.9
     * @author Kacper Faber
     */
    const [data, setData] = useState<Page<QRCodeStyle>>();

    const authContext = useContext(AuthContext);

    const [query, setQuery] = useState<GetListQuery>(defaultQuery);

    /**
     * Create new QRCodeStyle, refresh the state and return as a promise
     * @since 0.1.9
     * @author Kacper Faber
     */
    const create = async (payload: CreateAndPutPayload) => {
        const style = await QRCodeStyleApi.create(payload);
        reload();
        return style;
    }

    /**
     * Reload data in context.
     * @since 0.1.9
     * @author Kacper Faber
     */
    const reload = () => {
        if (!authContext.user) {
            setData(undefined);
            return;
        }

        QRCodeStyleApi.getList(query)
            .then(setData);
    }

    useEffect(reload, [query]);

    return (
        <QRCodeStyleContext.Provider
            children={props.children}
            value={{ data, setData, query, setQuery, reload, create }}
        />
    );
}

export default WrapQRCodeStyleContext;